import { useScreenSize } from "../../../hooks/useScreenSize";
import PublishablePreview from "../../../components/PublishablePreview";
import AdminLayout from "../Attachments/AdminLayout";
import ReferenceList from "./ReferenceList";
import ReferencesSectionForm from "./ReferencesSectionForm";

export default function ReferencesIndex({
  'references_sections': referencesSections,
  'expanded_section_references': expandedSectionReferences,
  'previewed_reference': previewedReference,
  'previewed_references_section': previewedReferencesSection,
  'references_section_id': referencesSectionId,
  'reference_id': referenceId
}: any) {
  const { screenLargerThan } = useScreenSize()

  return (
    <AdminLayout>
      <div style={{
        display: 'flex',
        flexDirection: screenLargerThan('md') ? 'row' : 'column',
        gap: '8px',
        flex: 1,
        minHeight: 0,
      }}>
        <div style={{
          flex: 1,
          overflowX: 'hidden',
          backgroundColor: '#ddd'
        }}>
          <ReferenceList
            referencesSections={referencesSections}
            expandedSectionReferences={expandedSectionReferences}
            expandedSectionId={referencesSectionId}
            previewedReferenceId={previewedReference?.id}
            searchQuery={referencesSections.metadata?.query}
          />
        </div>
        <div style={{
          flex: 2,
          minHeight: 0,
          overflow: 'hidden'
        }}>
          {referenceId == 'new' && (
            <PublishablePreview
              key="new-reference-preview"
              path="/admin/reference"
              recordKind="reference"
              referenceSectionOption={previewedReferencesSection?.option}
            />
          )}
          {referenceId == 'edit' && (
            <ReferencesSectionForm
              key={`references-section-form-${previewedReferencesSection?.id || 'new'}`}
              publishable={previewedReferencesSection || {}}
              path="/admin/references_sections"
            />
          )}
          {!['new', 'edit'].includes(referencesSectionId) && !['new', 'edit'].includes(referenceId) && (
            <PublishablePreview
              key={`reference-preview-${previewedReference?.id}`}
              publishable={previewedReference}
              frontendViewPath={`/reference/${previewedReference?.references_section_id}/${previewedReference?.id}`}
              referenceSectionOption={previewedReferencesSection?.option}
              recordKind="reference"
              path="/admin/reference"
            />
          )}
          {referencesSectionId == 'new' && (
            <ReferencesSectionForm
              key="references-section-form-new"
              path="/admin/references_sections"
            />
          )}
        </div>
      </div>
    </AdminLayout>
  )
}
